import { TOfferContextData } from '../../../../types/offer-card';

export const getAgentLevelInfo = (offerData: TOfferContextData) => {
  return offerData.offer.user?.agentModerationInfo?.userLevelInfo;
};

export const getIsUserIdentifiedByDocuments = (offerData: TOfferContextData) => {
  return offerData.offer.user?.agentModerationInfo?.isUserIdentifiedByDocuments || false;
};
